var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.hasFiles())?_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(_vm.$t("View")))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }